import React from 'react';

import {BackendSourceOptions, discoveryTracker} from '@udemy/browse-event-tracking';
import {useUDData} from '@udemy/ud-data';

import {TopicCard} from '../topic-card/topic-card.react-component';
import {EnrichedSkills} from './enriched-skills.react-component';
import {useLocaleContentfulData} from './hooks/useLocaleContentfulData';

interface TopicCard {
    title: string;
    url: string;
    learners: number;
    image: {
        url: string;
    };
}

export const EnrichedSkillsContainer = () => {
    const {request} = useUDData();
    const locale = request?.locale || 'en_US';
    const contentfulData = useLocaleContentfulData(locale);

    const onClick = (topicCard: TopicCard, index: number) => {
        discoveryTracker.trackDiscoveryItemClickEvent(
            {
                item: {
                    id: index,
                    title: topicCard.title,
                    type: 'course_topic',
                },
            },
            {
                backendSource: 'discovery' as BackendSourceOptions,
                index: index,
                uiRegion: 'learn_essential_skills',
            },
        );
    };

    const onImpression = (topicCard: TopicCard, index: number) => {
        discoveryTracker.trackDiscoveryImpression(
            {
                item: {
                    id: index,
                    title: topicCard.title,
                    type: 'course_topic',
                },
            },
            {
                backendSource: 'discovery' as BackendSourceOptions,
                index: index,
                uiRegion: 'learn_essential_skills',
            },
        );
    };

    const largeCardCarouselCollection = contentfulData?.data?.largeCardCarouselCollection;
    const firstItem = largeCardCarouselCollection?.items?.[0];

    if (!firstItem) {
        // Return null if no data is available - this prevents crashes
        return null;
    }

    const {title, description, skillCardCollection} = firstItem;
    const skillCards: TopicCard[] = skillCardCollection?.items || [];

    if (!Array.isArray(skillCards) || skillCards.length === 0) {
        return null;
    }

    return (
        <EnrichedSkills title={title} subtitle={description}>
            {skillCards.map((topicCard, i) => (
                <TopicCard
                    key={`topic-card-${i}`}
                    title={topicCard.title}
                    href={topicCard.url}
                    num_enrollments={topicCard.learners}
                    backgroundImageUrl={topicCard.image?.url}
                    onClick={() => onClick(topicCard, i)}
                    trackImpression={() => onImpression(topicCard, i)}
                />
            ))}
        </EnrichedSkills>
    );
};
